import syncBrokerageNow from 'Components/Banking/syncBrokerageNow';
import { notifyBrokerageDataChanged } from 'Components/Banking/brokerageDataBus';

// Status-Nachverfolgung einer frisch platzierten/geaenderten comdirect-Order
// (Chat vom 2026-08-09, Nutzerwunsch). Anders als IB pusht comdirect keine
// Statuswechsel - der aktuelle Stand kommt nur ueber eine aktive
// Synchronisierung (BrokerageSyncNow, siehe syncBrokerageNow). comdirect ist
// zudem deutlich langsamer, daher wird hier in 5-Sekunden-Schritten bis zu
// einer Minute gepollt und beim ersten erkannten Statuswechsel gestoppt.
//
// Bewusst lebenszyklus-UNABHAENGIG (reine setTimeout-Schleife auf x, kein
// React-State) - das Order-Formular wird direkt nach dem Absenden geschlossen
// (props.onDone), die Nachverfolgung soll aber weiterlaufen und ihre
// selbstschliessende Meldung (x.wah.addHint) auch dann noch zeigen koennen.

// Uebersetzungen wie im Orderbuch (BrokerageOrderbook.js, comdirect-Doku
// 7.2.3) - hier dupliziert, um keine Anzeige-Komponente importieren zu muessen.
const ORDER_STATUS_LABELS = {
	PENDING: 'In Bearbeitung',
	OPEN: 'Offen',
	EXECUTED: 'Ausgeführt',
	SETTLED: 'Abgerechnet',
	CANCELLED_USER: 'Gestrichen',
	EXPIRED: 'Verfallen',
	CANCELLED_SYSTEM: 'Abgelehnt',
	CANCELLED_TRADE: 'Storniert',
	UNKNOWN: 'Unbekannt',
	PARTIALLY_EXECUTED: 'Teilausgeführt',
	WAITING: 'Wartend',
};

const POLL_INTERVAL_MS = 5000;
const TIMEOUT_MS = 60000;

function fetchStatus(x, connectionId, orderId, cb) {
	x.was.axPost('Backend/webapp.php?module=Banking&task=BrokerageLocalOrderList', { connectionId }, (result) => {
		if (result.data.returncode !== 1) {
			cb(null);
			return;
		}
		const orders = result.data.content.orders || [];
		const match = orders.find((o) => String(o.orderId) === String(orderId));
		cb(match ? match.orderStatus : null);
	}, () => cb(null));
}

function label(status) {
	return ORDER_STATUS_LABELS[status] || status;
}

export default function pollComdirectOrderStatus(x, connectionId, orderId) {
	if (orderId == null) {
		return;
	}
	// BrokerageOrderConfirm/-Preview synchronisiert direkt nach dem Platzieren
	// (syncBrokerageData), die Order steht also schon mit ihrem Startstatus in
	// der lokalen Spiegelung - den als Vergleichsbasis nehmen.
	fetchStatus(x, connectionId, orderId, (initialStatus) => {
		let baseline = initialStatus;
		const startedAt = Date.now();

		const tick = () => {
			if (Date.now() - startedAt >= TIMEOUT_MS) {
				x.wah.addHint('Order ' + orderId + ': Status seit einer Minute unverändert (Zeitüberschreitung).');
				return;
			}
			syncBrokerageNow(x, connectionId, {
				onDone: () => {
					fetchStatus(x, connectionId, orderId, (status) => {
						if (status && baseline == null) {
							// Basis war beim Platzieren noch nicht ermittelbar -
							// jetzt nachziehen und weiter beobachten.
							baseline = status;
							setTimeout(tick, POLL_INTERVAL_MS);
							return;
						}
						if (status && status !== baseline) {
							x.wah.addHint('Order ' + orderId + ': Status jetzt „' + label(status) + '".');
							notifyBrokerageDataChanged(x);
							return;
						}
						setTimeout(tick, POLL_INTERVAL_MS);
					});
				},
				// Session zwischenzeitlich abgelaufen o.ae. - im Hintergrund
				// still beenden, KEIN Login-Dialog aufdraengen.
				onNeedsLogin: () => {},
				onError: () => {},
			});
		};

		setTimeout(tick, POLL_INTERVAL_MS);
	});
}
